import { SortableOrder } from '../sortable-order'

export class CommonOrdersSorter {
  static sort(orders: SortableOrder[]) {
    return [...orders].reverse()
  }
}
